import { ValidateSelectedVolunteerRequest } from "core/api/users/validateSelectedVolunteers";
import { ValidateVolunteerResponse } from "core/api/users/validateSelectedVolunteers";
import asyncThunk from "core/decorators/toolkit";
import api from "core/api";

export const validateSelectedVolunteer = asyncThunk<ValidateVolunteerResponse, ValidateSelectedVolunteerRequest>(
  "panel/beta/validateSelectedVolunteers",
  api.users.validateSelectedVolunteers
);
